import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const clientGroupMutations: UpdatesConfig['Mutation'] = {
  clientGroupCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('clientGroups', cache);
  },
  clientGroupUpdate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('clientGroups', cache);
  },
  clientGroupDelete: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('clientGroups', cache);
  },
};

export default clientGroupMutations;
